export default {
  // START:: NOTIFICATIONS GETTER
  notificationCountNumber(state) {
    console.log(JSON.parse(JSON.stringify(state)),state);
    return state.notificationCount;
  },
  notificationsData(state) {
    return {
      notificationsList: state.notifications,
      unreadNotifications: state.unreadNotifications,
    };
  },
  // END:: NOTIFICATIONS GETTER

  // START:: ALL READIED NOTIFICATIONS GETTER
  allReadiedNotificationsData(state) {
    return {
      allReadiedNotificationsList: state.allNotifications,
      unreadNotifications: state.unreadNotifications,
    };
  },
  // END:: ALL READIED NOTIFICATIONS GETTER
};
